var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c(_vm.settingsCompId,{tag:"component",attrs:{"show":_vm.enabled,"settings":_vm.settings},on:{"update:show":function($event){_vm.enabled=$event},"update":_vm.updateSettings}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }